import { useQuery } from '@tanstack/react-query';
import { COUNTRIES_KEY } from '../../utils/constants/queryKeys';
import { getCountries } from '../services/fn-api/Common';

export const useGetCountries = () => {
  return useQuery({
    queryKey: [COUNTRIES_KEY],
    queryFn: () => getCountries(),
  });
};
